import {FormikHelpers} from 'formik'
import {KTSVG} from '../../../_metronic/helpers'
import {useDispatch, useSelector} from 'react-redux'
import {getCommonState, loadRegisteredCardsAsync} from '../../redux/commonSlice'
import {getProductState, startPaymentAsync} from '../../redux/productSlice'
import {useNavigate} from 'react-router-dom'
import Translator from '../../components/common/translate/Translator'
import PaymentContractPopup from '../../components/purchase/PaymentContractPopup'
import Discount from '../../components/purchase/Discount'
import FormikForm from '../../components/form/FormikForm'
import CartDetails from '../../components/purchase/CartDetails'
import CardForm from '../../components/customer/finance/card/CardForm'
import {
  CardFormValues,
  CardInitialValues,
  CardSchema,
  NewCardTokenValue,
  TestCardInitialValues,
} from '../../utils/cardUtilities'
import {FormStatus} from '../../types/FormStatus'
import FormMessage from '../../components/common/messages/FormMessage'
import NormalTitle from '../../components/common/title/NormalTitle'
import {useEffect, useState} from 'react'
import CardSelection from '../../components/customer/finance/card/CardSelection'
import CardSelectionNew from '../../components/customer/finance/card/CardSelectionNew'
import {defterdar_log, getCurrencySymbol} from '../../utils/utilities'
import {CurrencyEnum} from '../../apiClient/enums'
import {getCompanyState} from '../../redux/companySlice'
import Installment from '../../components/purchase/Installment'
import {InstallmentDto} from '../../api/data-contracts'

function CartPaymentPage() {
  const productState = useSelector(getProductState)
  const commonState = useSelector(getCommonState)
  const companyState = useSelector(getCompanyState)
  const navigate = useNavigate()

  const dispatch = useDispatch()

  const [selectedInstallment, setSelectedInstallment] = useState<InstallmentDto | null>(null)
  useEffect(() => {
    dispatch<any>(loadRegisteredCardsAsync())
  }, [])

  const submitStep = async (values: CardFormValues, actions: FormikHelpers<CardFormValues>) => {
    try {
      await dispatch<any>(
        startPaymentAsync({
          request: {
            cardHolderName: values.nameOnCard,
            cardNumber: values.cardNumber,
            cvc: values.cardCvv,
            expireMonth: values.cardExpiryMonth,
            expireYear: values.cardExpiryYear,
            registerCard: values.registerCard,
            cardName: values.cardName,
            selectedCardToken: values.cardToken === NewCardTokenValue ? null : values.cardToken,
            paymentId: productState?.certainPaymentId,
            installment: selectedInstallment?.installment,
            installmentTotalAmount: selectedInstallment?.totalPrice,
          },
        })
      )
        .unwrap()
        .then((message: string) => {
          actions.setStatus(new FormStatus(false, message))
        })
    } catch (error) {
      console.error(error)
    } finally {
    }
  }

  const initValues: CardFormValues = {
    ...(process.env.REACT_APP_ENV?.includes('PROD') ? CardInitialValues : TestCardInitialValues),
    cardToken:
      (commonState.registeredCards?.length ?? 0) > 0
        ? commonState.registeredCards?.at(0)?.cardToken ?? null
        : NewCardTokenValue ?? null,
  }

  const getBinNumber = (cardNumber: string | undefined, cardToken: string | undefined) => {
    if (cardToken === NewCardTokenValue) {
      return cardNumber?.slice(0, 8) ?? ''
    }
    return (
      commonState.registeredCards?.find((card) => card.cardToken === cardToken)?.binNumber ?? ''
    )
  }

  return (
    <>
      <div className='d-flex flex-column flex-xl-row flex-row-fluid mt-10 h-100'>
        <div className='card justify-content-center justify-content-xl-start flex-row-auto w-100 w-xl-400px w-xxl-400px me-9 mb-10'>
          <div className='card-body pt-10 mb-10' style={{paddingLeft: 0, paddingRight: 0}}>
            <CartDetails />
          </div>
        </div>

        <div className='d-flex flex-row-fluid flex-center bg-body rounded w-100 mb-10 pb-10'>
          <div className={'w-100 h-100 d-flex flex-row-fluid '}>
            <FormikForm
              initialValues={initValues}
              onSubmit={submitStep}
              validationSchema={CardSchema}
            >
              {(form_props) => {
                return (
                  <div className='d-flex flex-center'>
                    <div className='w-100 mt-5'>
                      <NormalTitle text='ODEME' />

                      <div className='d-flex flex-center'>
                        <div className='row w-xs-100 w-sm-100 w-md-100 w-lg-50 w-xl-50 w-xxl-50'>
                          {commonState.registeredCards?.map((card) => (
                            <div key={card.cardToken} className='col-12 mb-5 px-5'>
                              <CardSelection card={card} setFieldValue={form_props.setFieldValue} />
                            </div>
                          ))}
                        </div>
                      </div>

                      <div className='d-flex flex-center'>
                        <div className='w-xs-100 w-sm-100 w-md-100 w-lg-50 w-xl-50 w-xxl-50'>
                          <div className='col-6 mb-5 px-5 w-100'>
                            {(commonState.registeredCards?.length ?? 0) > 0 && (
                              <CardSelectionNew setFieldValue={form_props.setFieldValue} />
                            )}
                          </div>
                          {(form_props.values.cardToken === NewCardTokenValue ||
                            (commonState.registeredCards?.length ?? 0) === 0) && (
                            <CardForm
                              isCardRegisterDisabled={
                                productState?.prices?.items?.some(
                                  (s) => (s.serviceLength ?? 0) > 1
                                ) ?? false
                              }
                              showCardNameInput={form_props.values.registerCard}
                              setFieldValue={form_props.setFieldValue}
                            />
                          )}

                          <div className='row mb-3'>
                            <div className='col-md-6'>
                              {productState.prices?.isDiscountAutomatic !== true && <Discount />}
                            </div>

                            <div className='col-md-6'>
                              {productState.prices?.isInstallmentEnabled === true &&
                                ((form_props.values.cardToken === NewCardTokenValue &&
                                  form_props.values.cardNumber) ||
                                  (form_props.values.cardToken !== NewCardTokenValue &&
                                    form_props.values.cardToken)) && (
                                  <Installment
                                    setFieldValue={form_props.setFieldValue}
                                    setSelectedInstallment={setSelectedInstallment}
                                    binNumber={getBinNumber(
                                      form_props.values.cardNumber ?? '',
                                      form_props.values.cardToken ?? ''
                                    )}
                                  />
                                )}
                            </div>
                          </div>

                          <div className='px-5'>
                            <PaymentContractPopup />
                          </div>

                          <div className='px-5 mt-5'>
                            <FormMessage {...form_props.status} />
                          </div>

                          <div className='d-flex flex-stack align-items-end mt-2 mb-25'>
                            <div className='mr-2'>
                              <button
                                onClick={function () {
                                  navigate(-1)
                                }}
                                type='button'
                                className='btn btn-lg btn-light-primary me-3'
                              >
                                <KTSVG
                                  path='/media/icons/duotune/arrows/arr063.svg'
                                  className='svg-icon-4 me-1'
                                />
                                <Translator name='GERI' />
                              </button>
                            </div>
                            <div>
                              {selectedInstallment && (
                                <div className='text-end'>
                                  <p>{selectedInstallment.installment} Taksit</p>
                                </div>
                              )}
                            </div>
                            <div>
                              <button
                                type='submit'
                                disabled={!form_props.isValid}
                                className='btn btn-lg btn-primary me-3'
                              >
                                <span className='indicator-label'>
                                  <Translator
                                    name='ODE'
                                    params={{
                                      Price: (
                                        selectedInstallment?.totalPrice ??
                                        productState.prices?.totalAmountWithDiscount
                                      )?.toFixed(1),
                                      Currency: getCurrencySymbol(
                                        productState.prices?.items?.at(0)?.currencyId ??
                                          CurrencyEnum.Türk_Lirası
                                      ),
                                    }}
                                  />
                                </span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )
              }}
            </FormikForm>
          </div>
        </div>
      </div>
    </>
  )
}

export default CartPaymentPage
